import { ThemeProvider } from '@mui/material';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { useDispatch } from 'react-redux';

import http from './api/httpClient';
import { appPath } from './AppRouter';
import { GlobalLoaderProvider } from './context/GlobalLoaderContext';
import useAppContext from './hooks/useAppContext';
import keycloak from './keycloak';
import { createCustomTheme } from './muiTheme';
import { setError } from './redux/status/actions';
import { fetchUserData } from './redux/user/actions';
import RouterGuard from './RouterGuard';

const App = () => {
  const dispatch = useDispatch();
  const { theme } = useAppContext();
  const customTheme = createCustomTheme(theme);

  function onKeycloakEvent(event: string): void {
    switch (event) {
      case 'onAuthSuccess': {
        const tokenParsed = keycloak.tokenParsed as { email?: string };
        dispatch(fetchUserData({ email: tokenParsed.email ?? '' }));
        break;
      }
      case 'onInitError':
        dispatch(setError('KEYCLOAK_INIT_ERROR'));
        break;
      default:
        break;
    }
  }

  return (
    <ThemeProvider theme={customTheme}>
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{
          onLoad: 'check-sso',
          checkLoginIframe: false,
          silentCheckSsoRedirectUri: `${window.location.origin}${appPath}/silent-check-sso.html`,
          messageReceiveTimeout: 5000,
        }}
        // Keeps headers in sync whenever token refreshes
        onTokens={(tokens): void => {
          if (tokens.token) {
            http.defaults.headers.common.Authorization = `Bearer ${tokens.token}`;
          }
        }}
        onEvent={onKeycloakEvent}
      >
        <GlobalLoaderProvider>
          <RouterGuard />
        </GlobalLoaderProvider>
      </ReactKeycloakProvider>
    </ThemeProvider>
  );
};

export default App;
